import React from 'react';

/**
 * No Results
 *
 * Use to display a message when no lists or search results are found
 */
const NoResults = ({ handleErrorMsg }) => {
  return (
    <div className="no-results col-span-full">
      <h3 className='heading-3'>{ handleErrorMsg }</h3>
    </div>
  );
};

export default NoResults;
